import { lazy, useEffect, useState } from 'react';
import { useLazyComponentPreload } from '@medifind/hooks';
import { IconBolt } from '@medifind/icons';
import { useMFModal } from '@medifind/popups';
import { changeURLParams, useRouter } from '@medifind/router';
import { Button } from '@medifind/shared-basic-components';
import { logEventGA4 } from '@medifind/zustand';

const RequestAppointmentForm = lazy(() => import('./RequestAppointmentForm'));

const RequestAppointmentModal = ({
  isOpen,
  label,
  classes,
  isPremium,
  doctorName,
  addresses,
  phone,
  personId,
  disabled,
  onClose,
  ...props
}) => {
  const router = useRouter();
  useLazyComponentPreload(RequestAppointmentModal, 20000);
  const { MFModal, openModal, closeModal } = useMFModal();
  const [step, setStep] = useState(1);

  const removedUrl = () => {
    changeURLParams(router, { bookOnline: null }, { type: 'replace' });
  };

  useEffect(() => {
    if (isOpen != null) {
      if (isOpen) {
        openModal();
      } else {
        closeModal();
        removedUrl();
      }
    }
  }, [closeModal, isOpen, openModal]);

  return (
    <>
      <Button
        classes={classes}
        type="normal"
        color="red"
        onClick={(event) => {
          logEventGA4('request_appointment', { action: 'open' });
          openModal();
          event.preventDefault();
          event.stopPropagation();
        }}
        label={label || 'Request appointment'}
        iconBefore={<IconBolt color="white" />}
        disabled={disabled}
      />
      <MFModal
        title={step == 2 ? 'Request submitted!' : 'Request a Doctor Appointment'}
        onClose={onClose}
        shouldCloseOnOverlayClick={false}
      >
        <RequestAppointmentForm
          isPremium={isPremium}
          doctorName={doctorName}
          addresses={addresses}
          phone={phone}
          {...props}
          onClose={closeModal}
          onStepChange={setStep}
        />
      </MFModal>
    </>
  );
};

export default RequestAppointmentModal;
